import styled, {css} from 'styled-components';

import {Flex} from 'components/base/Flex';
import {ButtonStyle} from 'components/design-guide/enums';
import {BorderRadius, FontFamily, FontSize, FontWeight, Spacing} from 'styles/Base';
import {Timing} from 'styles/Colors';

export const ActionStyleButtonComponent = styled(Flex)<{
  buttonStyle: ButtonStyle;
  disabled?: boolean;
  loadingSpinner?: {active?: boolean};
  selected?: boolean;
}>`
  height: ${({buttonStyle}) =>
    buttonStyle === ButtonStyle.SELECTOR
      ? `70px`
      : buttonStyle === ButtonStyle.SELECTOR_TOGGLE
        ? `72px`
        : buttonStyle === ButtonStyle.PILL || buttonStyle === ButtonStyle.SMALL_PILL
          ? `${Spacing.TWO}`
          : `${Spacing.TWO_5}`};
  ${({loadingSpinner, buttonStyle}) => css`
    padding-left: ${loadingSpinner
      ? Spacing.ZERO
      : buttonStyle === ButtonStyle.PILL
        ? Spacing.ZERO_5
        : buttonStyle === ButtonStyle.TOUCHPOINT || buttonStyle === ButtonStyle.SMALL_PILL
          ? Spacing.ZERO
          : Spacing.ONE_25};
    padding-right: ${loadingSpinner
      ? Spacing.ZERO
      : buttonStyle === ButtonStyle.PILL
        ? Spacing.ONE
        : buttonStyle === ButtonStyle.TOUCHPOINT || buttonStyle === ButtonStyle.SMALL_PILL
          ? Spacing.ZERO
          : Spacing.ONE_25};
    cursor: ${loadingSpinner?.active ? 'default' : 'pointer'};
  `}
  font-family: ${({buttonStyle}) => (buttonStyle === ButtonStyle.TOUCHPOINT ? undefined : FontFamily.AVENIR)};
  font-size: ${({buttonStyle}) =>
    [ButtonStyle.SELECTOR, ButtonStyle.SELECTOR_TOGGLE].includes(buttonStyle) ? FontSize.ZERO_875 : FontSize.ONE};
  font-weight: ${({buttonStyle}) =>
    [ButtonStyle.SELECTOR, ButtonStyle.SELECTOR_TOGGLE].includes(buttonStyle)
      ? FontWeight.SEMI_BOLD
      : FontWeight.MEDIUM};
  border-radius: ${({buttonStyle}) =>
    [ButtonStyle.SELECTOR, ButtonStyle.SELECTOR_TOGGLE].includes(buttonStyle)
      ? BorderRadius.EIGHT_PX
      : buttonStyle === ButtonStyle.PILL || buttonStyle === ButtonStyle.SMALL_PILL
        ? BorderRadius.SIXTEEN_PX
        : buttonStyle === ButtonStyle.TOUCHPOINT
          ? undefined
          : BorderRadius.THREE_PX};
  width: ${({buttonStyle}) => (buttonStyle === ButtonStyle.SMALL_PILL ? '80px' : '100%')};
  transition: background-color 0.2s ${Timing.COLOR_TRANSITION};
`;
